/* eslint-disable no-await-in-loop */
import React from 'react';
import ReactDOM from 'react-dom';
// base
import Loading from '../Loading';
import Collapse from '../Collapse';
import Icon from '../Icon';
import { getSysFieldid } from '@platform/api';
// api
import BaseRefer from './BaseRefer';

class Refer extends BaseRefer {
    constructor(props) {
        super(props);
        this.canload = true;
        this.interval = 0;
        if (props.clickContainer) {
            this.clickContainer = {
                ...props.clickContainer,
                props: {
                    ...props.clickContainer.props,
                    onClick: this.show,
                },
            };
            Object.defineProperty(this.clickContainer, 'props', {
                writable: false,
                configurable: false,
                value: this.clickContainer.props,
                enumerable: true,
            });
        }
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        delete this.referList;
    }

	// 计算参照输入框位置
	calcFixed = (dom, container = this.props.container) => {
	    if (dom && dom !== container) {
	        var pos = dom.getBoundingClientRect(),
	            top = pos.top,
	            left = pos.left,
	            referHeight = this.referContainer.offsetHeight,
	            dropDownWidth = this.referContainer.offsetWidth * this.props.columnConfig.length;
	        if (top + referHeight + 204 > document.body.clientHeight) {
	            top = top - referHeight - 208;
	        }
	        if (left + dropDownWidth > document.body.clientWidth) {
	            left = pos.right - dropDownWidth;
	        }
	        return {
	            top,
	            left,
	        };
	    } else {
	        return {
	            top: 0,
	            left: 0,
	        };
	    }
	};

	// 查询下级分类
	getOptions = async (item, level) => {
	    let { tableData } = this.state;
	    let { columnConfig, isTreeCanSelect, pageSize, isCacheable, idKey } = this.props;
	    if (Array.isArray(columnConfig) && columnConfig.length) {
	        //点击的是分类
	        if (columnConfig.length > level) {
	            //如果没到最后一级分类，则查询下级分类
	            // tableData.length = level + 1;
	            if (isTreeCanSelect) {
	                this.singleSelect(item);
	            }
	            tableData[level - 1].selectedData = item;
	            tableData[level] = tableData[level] || {
	                rows: [],
	                page: {
	                    pageIndex: 0,
	                    pageSize,
	                },
	            };
	            if (!(tableData[level].rows.length && isCacheable)) {
	                await this.loadTableData({
	                    pid: item[idKey],
	                    page: tableData[level].page,
	                }).then(data => {
	                    this.setTableData('tableData', level, data);
	                });
	            }
	            this.setState({
	                tableData,
	                currentLevel: level,
	            });
	        } else {
	            //否则选中数据
	            this.singleSelect(item);
	        }
	    } else {
	        //点击的是数据列，选中数据
	        this.singleSelect(item);
	    }
	};

	// 加载下一页的请求
	getMoreOptions = index => {
	    let { tableData } = this.state,
	        { queryGrideUrl, idKey } = this.props;
	    let pid = index ? tableData[index - 1].selectedData[idKey] : '';
	    tableData[index].page.pageIndex++;
	    let param = this.__getParam({
	            pageInfo: tableData[index].page,
	            pid,
	        }),
	        cacheData = this.hasCache(queryGrideUrl, param);
	    // console.log('第', index + 1, '级菜单加载下一页，现在第', tableData[index].page.pageIndex, '页');
	    if (cacheData) {
	        this.setTableData('tableData', index, cacheData);
	    } else {
	        this.loadTableData(param).then(data => {
	            this.setTableData('tableData', index, data);
	            this.canload = true;
	        });
	    }
	};

	//分页加载
	ulScroll = (level, e) => {
	    let { tableData, isShow } = this.state;
	    if (!isShow) {
	        return;
	    }
	    if (e.target.scrollTop > e.target.firstChild.clientHeight - e.target.clientHeight - 5) {
	        if (tableData[level].page.pageIndex < tableData[level].page.totalPage - 1) {
	            this.canload && this.getMoreOptions(level);
	            // 防止多次请求
	            this.canload = false;
	        }
	    }
	};

	// 复写原型方法：点击参照三个点的事件
	show = () => {
	    let { columnConfig, disabled, isCacheable, queryGridUrl } = this.props;
	    if (disabled) {
	        return false;
	    }
	    let { tableData, currentLevel } = this.state,
	        param,
	        cacheData;
	    currentLevel = 0;
	    tableData[currentLevel].rows = [];

	    this.setState(
	        {
	            currentLevel,
	            dropDownShow: false,
	            isShow: true,
	        },
	        () => {
	            if (!(tableData[currentLevel].rows.length && isCacheable)) {
	                if (typeof columnConfig === 'object' && columnConfig.length > 1) {
	                    // 多级菜单型
	                    tableData[0].rows = [];
	                    tableData.length = 1;
	                    this.asyncLoad();
	                } else {
	                    // 列表型
	                    param = this.__getParam();
	                    cacheData = this.hasCache(queryGridUrl, param);
	                    if (cacheData) {
	                        this.setTableData('tableData', currentLevel, cacheData);
	                    } else {
	                        this.loadTableData(param).then(data => {
	                            this.setTableData('tableData', currentLevel, data);
	                        });
	                    }
	                }
	            }
	            this.referInput && this.referInput.focus();
	        },
	    );
	};

	// 复写原型方法：下拉
	renderDropDown = () => {
	    let { tableData, currentLevel, selectedValues, isShow, loading } = this.state;
	    let { columnConfig, ellipsis, container, idKey, attrcode, fieldid } = this.props;
	    // let multiMenuWidth = columnConfig.length ? (currentLevel + 1) * fixWidth + currentLevel * 4 : '100%';
	    let fixWidth = (this.referContainer && this.referContainer.offsetWidth) || 0;
	    let multiMenuWidth = columnConfig.length
	        ? columnConfig.length * fixWidth + (columnConfig.length - 1) * 4
	        : fixWidth;
	    let fieldidValue = null;
	    if (fieldid || attrcode) {
	        fieldidValue = `${fieldid || attrcode}_refer`;
	    }
	    fieldidValue = getSysFieldid(fieldidValue);
	    return ReactDOM.createPortal(
	        <div
	            fieldid={fieldidValue}
	            className="refer-container u-dropdown dropdown-refer"
	            onMouseDown={e => {
	                e.preventDefault();
	            }}
	        >
	            <Loading container={this.referList} show={false} />
	            <Collapse
	                in={isShow}
	                style={{
	                    overflow: 'hidden',
	                    width: multiMenuWidth,
	                    top:
							this.calcFixed(this.referContainer).top +
							(this.referContainer ? this.referContainer.offsetHeight : 0) +
							4,
	                    left: this.calcFixed(this.referContainer).left,
	                    position: 'fixed',
	                }}
	            >
	                <div
	                    ref={dom => {
	                        this.referList = dom;
	                    }}
	                    className="refer-cascading-list clearfix"
	                >
	                    <div style={{ width: '100%', overflow: 'auto' }}>
	                        <div
	                            style={{
	                                width: multiMenuWidth,
	                                backgroundColor: '#eee',
	                                overflowY: 'hidden',
	                            }}
	                        >
	                            {tableData.map((list, level) => {
	                                if (currentLevel >= level) {
	                                    return (
	                                        <div
	                                            className="scroll-div"
	                                            key={level}
	                                            style={{ width: (multiMenuWidth - currentLevel * 4) / columnConfig.length }}
	                                        >
	                                            <p className="list-title">{columnConfig[level].name.join('/')}</p>
	                                            <div
	                                                className="refer-scroll"
	                                                onScroll={e => {
	                                                    this.ulScroll(level, e);
	                                                }}
	                                            >
	                                                <ul
	                                                    className="refer-cascading-item"
	                                                    key={level}
	                                                    style={{ width: columnConfig.length ? 'auto' : '100%' }}
	                                                >
	                                                    {list.rows.map((item, i) => {
	                                                        let label = columnConfig[level].code
	                                                            .map(e => {
	                                                                return item[e] || item.values?.[e]?.value;
	                                                            })
	                                                            .join('/');
	                                                        return (
	                                                            <li
	                                                                title={label}
	                                                                className={
	                                                                    'clearfix refer-li' +
																		(selectedValues.has(item[idKey])
																		    ? ' selected'
																		    : '') +
																		(list.selectedData &&
																			list.selectedData[idKey] === item[idKey]
																		    ? ' active'
																		    : '')
	                                                                }
	                                                                key={i}
	                                                                onClick={this.getOptions.bind(
	                                                                    this,
	                                                                    item,
	                                                                    Number(level) + 1,
	                                                                )}
	                                                            >
	                                                                {ellipsis &&
																		level > 0 &&
																		level === columnConfig.length - 1 ? (
	                                                                        label.replace(
	                                                                            tableData[level - 1].selectedData.refname,
	                                                                            '...',
	                                                                        )
	                                                                    ) : (
	                                                                        label
	                                                                    )}
	                                                                {level < columnConfig.length - 1 && (
	                                                                    <Icon
	                                                                        type="uf-anglearrowpointingtoright"
	                                                                        style={{
	                                                                            position: 'absolute',
	                                                                            right: '-4px',
	                                                                            top: '50%',
	                                                                            marginTop: ' -9px',
	                                                                        }}
	                                                                    />
	                                                                )}
	                                                            </li>
	                                                        );
	                                                    })}
	                                                </ul>
	                                            </div>
	                                        </div>
	                                    );
	                                } else {
	                                    return null;
	                                }
	                            })}
	                        </div>
	                    </div>
	                </div>
	            </Collapse>
	        </div>,
	        container,
	    );
	};

	// 第一次查询的时候把多列的每一列数据都查出来
	asyncLoad = async function () {
	    let { queryGrideUrl, columnConfig } = this.props,
	        { tableData } = this.state,
	        param = this.__getParam(),
	        cacheData = this.hasCache(queryGrideUrl, param);
	    if (cacheData) {
	        this.setTableData('tableData', 0, cacheData);
	    } else {
	        await this.loadTableData(param).then(data => {
	            this.setTableData('tableData', 0, data);
	        });
	    }
	    let length = columnConfig.length;
	    for (let i = 1; i < length; i++) {
	        if (tableData[i - 1].rows[0]) {
	            tableData[i - 1].selectedData = tableData[i - 1].rows[0];
	            await this.getOptions(tableData[i - 1].rows[0], i);
	        }
	    }
	};
}

export default Refer;
